var common = require("../../utiles/common")

module.exports = {
    register: function () {
        document.createElement('user-switch')
        ko.components.register('user-switch', {
            viewModel: function (params) {
                console.log(params.userList)
                var $this = this;
                $this.title = params.title;
                $this.arrs = params.userList();
                $this.closeUserModal = function () {
                    params.userList([]);
                }
                $this.active = ko.observable("");
                $this.setId = function (id) {
                    console.log(id);
                    $this.active(id);
                }

                $this.SubmitIdentity = function () {
                    var data = JSON.stringify({ subjectId: $this.active() });
                    if (params.isLogin) {
                        common.fetch("/auth/switchUser", {
                            type: "POST",
                            data: data,
                            success: function (result) {
                                params.userList([]);
                                common.redirectTo("/#/");
                                params.callback(result);
                            },
                        });
                    } else {
                        common.fetch("/auth/selectUser", {
                            type: "post",
                            data: data,
                            success: function (data) {
                                params.callback(data);
                            }
                        });
                    }
                }
            },
            template: require("./UserSwitch.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/login/UserSwitch.js
// module id = 107
// module chunks = 0